/*import './App.css';
import Main from './components/Main';

function App() {
  return (
    <div className="App">
      <div className="Main">
        <Main />

      </div>
    </div>
  );
}

export default App;
*/

import { useEffect } from 'react';
import './App.css';
import Main from './components/Main';

function App() {

  useEffect(() => {
    const cursor = document.getElementById("customCursor");
    const moveCursor = function(e){
        cursor.style.left = e.clientX + "px";
        cursor.style.top = e.clientY + "px";
    };
    document.addEventListener("mousemove", moveCursor);

    return () => {
        document.removeEventListener("mousemove", moveCursor);
    };
  }, []);

  return (
    <div className="App">
      <div className="Main">
        <Main />
      </div>
      <div id="customCursor"></div>
    </div>
  );
}

export default App;